module.exports = __webpack_public_path__ + "static/assets/ecb1cbda3b9c4f29ab971734d97e3faf.mp3";